import React, { useState } from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import './Locations.css';

const Locations = () => {
  const [selectedLocation, setSelectedLocation] = useState(0);

  const locations = [
    {
      name: 'St George\'s Road',
      address: '427 St George\'s Rd, Glasgow G3 6JX',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2238.3!2d-4.2769!3d55.8719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488845d4b29d45a3%3A0x0!2s427%20St%20George\'s%20Rd%2C%20Glasgow%20G3%206JX!5e0!3m2!1sen!2suk!4v1234567890',
      type: 'Take Away Only',
    },
    {
      name: 'Queen Margaret Drive',
      address: '106 and 108 Queen Margaret Drive, Glasgow G20 8N',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2237.8!2d-4.2858!3d55.8779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488845e2f4d5e8a1%3A0x0!2s106%20Queen%20Margaret%20Dr%2C%20Glasgow%20G20%208NY!5e0!3m2!1sen!2suk!4v1234567890',
      type: 'Take Away & Dine In',
    },
  ];

  const openingHours = {
    stGeorges: [
      { day: 'Sunday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
      { day: 'Monday', hours: 'Closed' },
      { day: 'Tuesday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
      { day: 'Wednesday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
      { day: 'Thursday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
      { day: 'Friday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
      { day: 'Saturday', hours: '12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM' },
    ],
    queenMargaret: [
      { day: 'Sunday', hours: '10:00 AM - 10:00 PM' },
      { day: 'Monday', hours: 'Closed' },
      { day: 'Tuesday', hours: '10:00 AM - 10:00 PM' },
      { day: 'Wednesday', hours: '10:00 AM - 10:00 PM' },
      { day: 'Thursday', hours: '10:00 AM - 10:00 PM' },
      { day: 'Friday', hours: '10:00 AM - 10:00 PM' },
      { day: 'Saturday', hours: '10:00 AM - 10:00 PM' },
    ],
  };

  const currentHours = selectedLocation === 0 ? openingHours.stGeorges : openingHours.queenMargaret;

  return (
    <section id="locations" className="locations-section">
      <div className="locations-container">
        <div className="locations-header animate-fade-in-up">
          <h2 className="section-title">Our Locations</h2>
          <div className="title-divider"></div>
        </div>

        <div className="locations-content">
          <div className="location-selector">
            {locations.map((location, index) => (
              <button
                key={index}
                className={`location-btn ${selectedLocation === index ? 'active' : ''}`}
                onClick={() => setSelectedLocation(index)}
              >
                <MapPin size={20} />
                {location.name}
              </button>
            ))}
          </div>

          <div className="location-details">
            <div className="map-container">
              <iframe
                src={locations[selectedLocation].mapUrl}
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={locations[selectedLocation].name}
              ></iframe>
            </div>

            <div className="info-cards">
              <div className="info-card hover-lift">
                <div className="info-icon">
                  <MapPin size={24} />
                </div>
                <h3 className="info-title">Address</h3>
                <p className="info-text">{locations[selectedLocation].address}</p>
                <p className="info-badge">{locations[selectedLocation].type}</p>
              </div>

              <div className="info-card hover-lift">
                <div className="info-icon">
                  <Phone size={24} />
                </div>
                <h3 className="info-title">Phone</h3>
                <a href="tel:0141 378 3469" className="info-text info-link">0141 378 3469</a>
              </div>

              <div className="info-card hover-lift">
                <div className="info-icon">
                  <Clock size={24} />
                </div>
                <h3 className="info-title">Opening Hours</h3>
                <div className="hours-list">
                  {currentHours.map((item, index) => (
                    <div key={index} className="hours-item">
                      <span className="hours-day">{item.day}</span>
                      <span className="hours-time">{item.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
